const en = {
  app: { title: 'Proxio' },
  common: {
    refresh: 'Refresh',
    or: 'or',
    cancel: 'Cancel',
    reset: 'Reset',
    save: 'Save',
    send: 'Send',
    search: 'Search',
    edit: 'Edit',
    add: 'Add',
    new: 'New',
    discard: 'Discard',
    yes: 'Yes',
    no: 'No',
    view: 'View',
    delete: 'Delete',
    start: 'Start',
    stop: 'Stop',
    end: 'End',
    select: 'Select',
    continue: 'Continue',
    filters: 'Filters',
    buy: 'Buy',
    back: 'Back',
    viewMore: 'View more',
    viewLess: 'View less',
    success: 'Success',
    successUpper: 'SUCCESS',
    errorUpper: 'ERROR',
    required: 'Required',
    notrequired: 'Not Required',
    inProgress: 'In progress...',
    btn: {
      save: 'Save',
      update: 'Update',
      cancel: 'Cancel',
      reset: 'Reset',
      abort: 'Abort',
      upload: 'Upload',
      uploadNewVersion: 'Upload New Version',
      yes: 'YES',
      no: 'NO',
      close: 'CLOSE',
      submit: 'Submit',
      copy: 'Copy',
      copyUrl: 'Copy URL',
      copyEmbededPlayer: 'Copy Embeded Player',
      play: 'Play',
    },
    all: 'All',
  },
  drawer: { compose: 'Compose', chats: 'Chats', normalizedAudio: 'Normailized Audio', unfulfilledRequests: 'Discrepancy Report', transcoder: 'Transcoder', requestAssignment: 'Request Assignment' },
  auth: {
    tenants: 'Workspaces',
    profile: {
      title: 'Profile',
      success: 'Profile successfully updated',
    },
    availableCredits: 'Available Credits',
    createAnAccount: 'Create an account',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password',
    signin: 'Sign in',
    signup: 'Sign up',
    signout: 'Sign out',
    alreadyHaveAnAccount: 'Already have an account? Sign in.',
    signinWithAnotherAccount: 'Sign in with another account',
    emailUnverified: {
      message: `Please confirm your email at <strong>{0}</strong> to continue.`,
      submit: `Resend email verification`,
    },
    emptyPermissions: {
      message: `You have no permissions yet. Wait for the admin to grant you privileges.`,
    },
    passwordResetEmail: {
      message: 'Send password reset email',
      error: `Email not recognized`,
    },
    passwordReset: {
      message: 'Reset password',
    },
    passwordChange: {
      title: 'Change Password',
      success: 'Password successfully changed',
      mustMatch: 'Passwords must match',
    },
    emailAddressVerificationEmail: {
      error: `Email not recognized`,
    },
    verificationEmailSuccess: `Verification email successfully sent`,
    passwordResetEmailSuccess: `A password reset email has been sent.`,
    passwordResetSuccess: `Password successfully changed`,
    verifyEmail: {
      success: 'Email successfully verified.',
      message: 'Just a moment, your email is being verified...',
    },
    register: {
      success: 'Registration successful. You can now log in.',
    },
    jwt: {
      error: {
        notAdmin: 'This is not a valid admin email.',
        onlyAdmin: 'Only Stringr Admin clients can log in this system.',
        missingRequiredField: 'Invalid JWT response from the server.',
      },
    },
  },
  
}

export default en
